module.exports = __webpack_public_path__ + "img/car-odometer.94278bac.svg";